// Not Yet Tested
import {Component, Input, OnInit} from "@angular/core";
import {FileUploadService} from "../../services/common/file-upload.service";
import {SweetAlertService} from "../../services/common/sweet-alert.service";

@Component({
  selector: 'app-single-file-upload',
  templateUrl: './single-upload-file.component.html',
  styleUrls: ['./single-upload-file.component.scss']
})
export class SingleUploadFileComponent implements OnInit {
  @Input() link: string;
  @Input() header: string;

  loading: boolean = false;
  file: File = null;

  constructor(private fileUploadService: FileUploadService) { }

  ngOnInit(): void {
  }

  onChange(event) {
    this.file = event.target.files[0];
  }

  onUpload() {
    this.loading = !this.loading;
    this.fileUploadService.upload(this.file, this.link, this.header).subscribe(
      (result: any) => {
          this.loading = false;
      }, (error) => {
        SweetAlertService.swalError(error)
        this.loading = false;
      }
    );
  }
}
